<template>
    <div class="upload-group">
        <div class="input-btn-group fl">
            <div class="swb-btn swb-btn-small left-radio">
                <input type="button" style="width: 100%" name="btnSelectFile">
                <i class="icon iconfont icon-wenjianjia mr5"></i>
                <span>选择</span>
            </div>
        </div>
        <label class="filename" name="selectedFiles"></label>
        <div class="input-btn-group fl">
            <div class="swb-btn right-radio swb-btn-small swb-btn-primary">
                <input type="button" style="width: 100%" @click="doUpload()">
                <i class="icon iconfont icon-shangchuan mr5"></i>
                <span>上传</span>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils, $, H5file } from '../../app.base'
    import { Vue } from '../../app.vues'
    //
    let fnGetUploadFileLimit = null;
    if(typeof getUploadFileLimit === 'function') {
        fnGetUploadFileLimit = getUploadFileLimit;
    }

    export default {
        name: 'swb-file-upload',
        desc: '文件上传',
        props: {
            serverUrl: {
                type: String,
                default: '/file/upload'
            },
            //文件细分场景用途
            fileFor: {
                type: String,
                default: null
            },
            //文件MIME限制（,分隔） 比如 image/jpg,image/png
            accept: {
                type: String,
                default: '*/*'
            },
            fileGroup: {
                type: String,
                default: 'file-misc'
            },
            useMd5: {
                type: Boolean,
                default: true
            },
            updateFileUuid: {
                type: String,
                default: null
            },
            multipleFile: {
                type: Boolean,
                default: false
            },
            onChange: {
                //fileItems, uploader
                type: Function
            },
            onBeforeUpload: {
                //fileItems, uploader
                type: Function
            },
            onProgress: {
                //progress, uploader
                type: Function
            },
            onDone: {
                //result
                type: Function
            },
            onFail: {
                //result
                type: Function
            },
            usage: {
                type: String,
                default: null
            },
            //自定义信息
            custData: {
                default: null
            }
        },

        watch: {
            serverUrl(val, oldValue) {
                this.$fileUploader.serverUrl(val);
            },
            accept(val, oldValue) {
                this.$fileUploader.accept(val || '*/*');
            },
            multipleFile(val, oldValue) {
                this.$fileUploader.multiple(val);
            },
            updateFileUuid(val, oldValue) {
                console.log("要更新的uuid:" + this.updateFileUuid);
            },
            usage(newVal, oldVal) {
                console.log("要更新的usage:" + this.usage);
            }
        },
        data() {
            return {
                $fileUploader: null
            }
        },
        //
        mounted() {
            let self = this;
            let parent = self.$parent || null;
            //
            var jqWrapper = $(this.$el);
            let proxyBtn = jqWrapper.find('input[name="btnSelectFile"]');
            let proxyName = jqWrapper.find('label[name="selectedFiles"]');
            //
            this.$fileUploader = H5file.Uploader.newOne();
            //
            this.$fileUploader.serverUrl(this.serverUrl);
            this.$fileUploader.accept(this.accept);
            this.$fileUploader.multiple(this.multipleFile);
            //
            this.$fileUploader.bindTo(proxyBtn);
            //
            this._fileChangeHanlder = function (fileItems, uploader) {
                var fileNames = fileItems.pluck('name');
                proxyName.html(fileNames.join(', '));
                //
                if(self.onChange) {
                    self.onChange.call(parent, fileItems, uploader);
                }
            };
            this.$fileUploader.changeHandler(this._fileChangeHanlder);
            //
            let uploadFileLimit = null;
            if(fnGetUploadFileLimit != null) {
                uploadFileLimit = fnGetUploadFileLimit(this.fileFor) || null;
            }
            //
            this._beforeUpload = function (fileItems, uploader) {
                if(uploadFileLimit != null) {
                    let chkMsg = null;
                    if(fileItems.length > uploadFileLimit.count) {
                        chkMsg = "允许单次上传的文件数量为：" + uploadFileLimit.count + " 个";
                    }
                    else {
                        for(let i = 0; i < fileItems.length; i++) {
                            let fileItem = fileItems[i];
                            let fileSize = fileItem.size;
                            if(fileSize > uploadFileLimit.size) {
                                chkMsg = "文件大小不能超过 " + uploadFileLimit.sizeStr;
                                break;
                            }
                            let fileExt = Utils.extractFileNameExt(fileItem.name).toLowerCase();
                            if(!uploadFileLimit.exts.contains(fileExt)) {
                                chkMsg = "允许的文件扩展名为：" + uploadFileLimit.exts.join(", ");
                                break;
                            }
                        }
                    }
                    if(chkMsg != null) {
                        self.$alert(chkMsg, "提示", {
                            type: "warning",
                            closeOnClickModal: true
                        });
                        return false;
                    }
                }
                //
                uploader.params({
                    whatFor: self.fileFor || null,
                    group: self.fileGroup || null,
                    update: !Utils.isNoB(self.updateFileUuid),
                    useMd5: self.useMd5,
                    uuid: self.updateFileUuid || null,
                    custData: self.custData || null,
                    usage: self.usage
                });
                //
                if(self.onBeforeUpload) {
                    return self.onBeforeUpload.call(parent, fileItems, uploader);
                }
            };
            this.$fileUploader.beforeUpload(this._beforeUpload);
            //
            this._progressHandler = function (progress, uploader) {
                if(self.onProgress) {
                    self.onProgress.call(parent, progress, uploader);
                }
            };
            this.$fileUploader.progressHandler(this._progressHandler);
            //
            this._uploadDone = function (result) {
                if(result.type != 'info') {
                    //汇合错误信息
                    let resultData = result.data;
                    if(resultData != null && resultData.files) {
                        let errMsgs = [];
                        //处理返回的文件信息
                        let files = resultData.files || [];
                        let fileCount = files.length;
                        for(let i = 0; i < fileCount; i++) {
                            let file = files[i];
                            if(file.type != "info") {
                                errMsgs.add((i + 1) + "、" + (file.message || "未知错误"));
                            }
                        }
                        let errCount = errMsgs.length;
                        if(errCount > 0) {
                            result.message = (errCount < fileCount ? (errCount + '/' + fileCount) : '') + "文件上传失败：\n" + errMsgs.join("\n");
                        }
                    }
                }
                //
                if(self.onDone) {
                    self.onDone.call(parent, result);
                    //清除选择的文件名称
                    if(result.type === 'info') {
                        proxyName.html('');
                    }
                }
                else {
                    console.log(result);
                }
            };
            this.$fileUploader.done(this._uploadDone);
            //
            this._uploadFail = function (result) {
                if(self.onFail) {
                    self.onFail.call(parent, result);
                }
                else {
                    self.$alert(result.message, "提示", {
                        type: "warning",
                        closeOnClickModal: true
                    });
                }
            };
            this.$fileUploader.fail(this._uploadFail);
            //
            this.$fileUploader.init();
        },

        beforeDestroy() {
            if(this.$fileUploader != null) {
                this.$fileUploader.destroy();
                //
                this.$fileUploader = null;
            }
            //
            this.onChange = null;
            this.onBeforeUpload = null;
            this.onProgress = null;
            this.onDone = null;
            this.onFail = null;
            this.custData = null;
        },
        //
        methods: {
            doUpload() {
                if(Utils.repeatChecker.isValidFor('FileUpload-ctrl', 1000)) {
                    this.$fileUploader.upload();
                }
            }
        }

    }

</script>



// WEBPACK FOOTER //
// src/compo/ctrl/FileUpload.vue